import { createContext, useContext, useEffect, useState } from "react"

// type Theme = "dark" | "light" | "system"
type Theme = "dark"

type ThemeProviderState = {
  theme: Theme
  setTheme: (theme: Theme) => void
}

// const initialState: ThemeProviderState = {
//   theme: "system",
//   setTheme: () => null,
// }
const initialState: ThemeProviderState = {
  theme: "dark",
  setTheme: () => null,
}

export const ThemeProviderContext = createContext<ThemeProviderState>(initialState)

export const useTheme = () => {
  const context = useContext(ThemeProviderContext)

  if (context === undefined)
    throw new Error("useTheme must be used within a ThemeProvider")

  return context
}

export const useThemeLogic = () => {
  // const [theme, setTheme] = useState<Theme>(
  //   () => (localStorage.getItem("vite-ui-theme") as Theme) || "system"
  // )
  const [theme, setTheme] = useState<Theme>("dark")

  useEffect(() => {
    const root = window.document.documentElement
    root.classList.remove("light", "dark")
    root.classList.add("dark")
  }, [])

  const setValue = (_theme: Theme) => {
    // localStorage.setItem("vite-ui-theme", theme)
    // setTheme(theme)
    // Artık tema değiştirilemez, fonksiyon boş bırakıldı
  }

  return {
    theme,
    setTheme: setValue,
  }
} 